(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["havoc-led-kit"]) return;
  try {
    
  class HavocLEDKit extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.data = JSON.parse(this.querySelector('[data-kit-data]').textContent);
      this.labels = this.data.labels;
      this.root = this.dataset.root;
      this.storageKey = 'havoc-kit-transaction-v1';
      this.busy = false;
      this.form = this.querySelector('[data-form]');
      this.controls = this.querySelector('[data-controls]');
      this.addButton = this.querySelector('[data-add]');
      this.status = this.querySelector('[data-status]');
      this.recovery = this.querySelector('[data-recovery]');
      this.another = this.querySelector('[data-another]');
      this.manualRestart = this.querySelector('[data-manual-restart]');
      this.reviewed = this.querySelector('[data-reviewed]');
      this.restart = this.querySelector('[data-restart]');
      this.form.addEventListener('submit', e => { e.preventDefault(); this.addKit(); });
      this.form.addEventListener('change', () => this.render());
      this.addButton.addEventListener('click', () => this.addKit());
      this.querySelector('[data-check]').addEventListener('click', () => this.recover());
      this.reviewed.addEventListener('change', () => { this.restart.disabled = !this.reviewed.checked || this.busy; });
      this.restart.addEventListener('click', () => this.restartAfterReview());
      this.another.addEventListener('click', () => {
        if (this.busy || !this.pending || this.pending.state !== 'complete') return;
        this.persist(null); this.confirmedTotal = undefined; this.status.textContent = ''; this.recovery.hidden = true; this.render();
      });
      try {
        sessionStorage.setItem('havoc-kit-storage-test','1'); sessionStorage.removeItem('havoc-kit-storage-test');
        this.pending = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null');
      } catch { this.status.textContent = this.labels.storage; return; }
      this.render();
      if (this.pending) {
        const properties = this.pending.items[0].properties;
        const radio = this.form.querySelector(`[name=channels][value="${properties._havoc_channels}"]`);
        if (radio) radio.checked = true;
        this.form.querySelector('[name=pcb]').value = properties.PCB;
        this.render();
        for (const expected of this.pending.items.slice(1)) {
          const variant = this.data.strips.variants.find(v=>String(v.id)===String(expected.id));
          const slot = expected.properties._havoc_slot.replace('channel-','');
          const select = this.form.querySelector(`[data-length="${slot}"]`);
          if (select && variant) select.value = variant.option1;
        }
        this.render(); this.recover();
      }
    }
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.data.currency || 'USD'}).format(cents / 100); }
    persist(value) { if (value) sessionStorage.setItem(this.storageKey,JSON.stringify(value)); else sessionStorage.removeItem(this.storageKey); this.pending = value; }
    selection() {
      const count = Number(this.form.querySelector('[name=channels]:checked').value);
      const color = this.form.querySelector('[name=pcb]').value;
      const controller = this.data.controller?.variants?.find(v => v.title === `${count} Channel`);
      const strips = Array.from({length:count},(_,i) => {
        const length = this.form.querySelector(`[data-length="${i+1}"]`).value;
        return this.data.strips?.variants?.find(v => v.option1 === length && v.option2 === color);
      });
      return { count,color,controller,strips,variants:[controller,...strips] };
    }
    render() {
      const count = Number(this.form.querySelector('[name=channels]:checked').value);
      const color = this.form.querySelector('[name=pcb]').value;
      for (const select of this.form.querySelectorAll('[data-length]')) {
        const previous = select.value;
        select.replaceChildren();
        for (const v of this.data.strips?.variants || []) {
          if (v.option2 !== color) continue;
          const option = new Option(`${v.option1} · ${this.money(v.price)}`,v.option1);
          select.add(option);
        }
        if (Array.from(select.options).some(o=>o.value === previous)) select.value = previous;
        const visible = Number(select.dataset.length) <= count;
        select.closest('[data-channel-row]').hidden = !visible;
        select.disabled = !visible;
      }
      const s=this.selection();
      const valid=s.variants.every(v=>v && v.available && (!v.quantity_rule || (v.quantity_rule.min<=1 && v.quantity_rule.increment===1 && (v.quantity_rule.max===null || v.quantity_rule.max>=1))));
      const summary=this.querySelector('[data-summary]'); summary.replaceChildren();
      s.variants.forEach((v,i)=>{const li=document.createElement('li');li.textContent=v ? `${i ? `${this.labels.channel} ${i}` : this.labels.controller}: ${v.title} · ${this.money(v.price)}` : this.labels.unavailable;summary.append(li);});
      this.querySelector('[data-total]').textContent=this.pending?.state==='complete' && this.confirmedTotal !== undefined ? this.money(this.confirmedTotal) : s.variants.every(Boolean)?this.money(s.variants.reduce((sum,v)=>sum+v.price,0)):'—';
      this.controls.disabled=this.busy || !!this.pending;
      this.addButton.disabled=!valid || this.busy || !!this.pending;
      this.restart.disabled=this.busy || !this.reviewed.checked;
      this.addButton.textContent=this.busy?this.labels.adding:this.labels.add;
      if (!valid && !this.pending && !this.busy) this.status.textContent=this.labels.unavailable;
      else if(this.status.textContent===this.labels.unavailable) this.status.textContent='';
    }
    async getJSON(endpoint) {
      const response=await fetch(this.root+endpoint,{headers:{Accept:'application/json'},credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(15000)});
      if(!response.ok) throw new Error(this.labels.error);
      return response.json();
    }
    async cart() { return this.getJSON('cart.js'); }
    inspect(cart) {
      const lines=cart.items.filter(i=>i.properties?._havoc_kit===this.pending.id);
      const exact=lines.length===this.pending.items.length && this.pending.items.every(expected=>lines.filter(i=>String(i.variant_id)===String(expected.id) && i.properties._havoc_slot===expected.properties._havoc_slot && i.quantity===1).length===1);
      return {lines,exact};
    }
    async recover() {
      if(this.busy || !this.pending) return;
      this.busy=true; this.render();
      try { await this.reconcile(await this.cart(),false); }
      catch { this.status.textContent=this.labels.uncertain; this.recovery.hidden=false; }
      finally { this.busy=false; this.render(); }
    }
    async restartAfterReview() {
      if(this.busy || !this.pending || !this.reviewed.checked) return;
      this.busy=true;this.restart.disabled=true;this.render();
      try {
        const cart=await this.cart();
        if(this.inspect(cart).lines.length) { await this.reconcile(cart,false); return; }
        this.persist(null);this.confirmedTotal=undefined;this.recovery.hidden=true;this.manualRestart.hidden=true;this.reviewed.checked=false;this.status.textContent='';
      } catch { this.status.textContent=this.labels.uncertain; }
      finally { this.busy=false;this.restart.disabled=!this.reviewed.checked;this.render(); }
    }
    async reconcile(cart,navigate) {
      const {lines,exact}=this.inspect(cart);
      this.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'havoc-led-kit',data:{itemCount:cart.item_count,source:'havoc-led-kit'}}}));
      this.recovery.hidden=false;
      this.another.hidden=true;
      this.manualRestart.hidden=true;
      if(exact) {
        this.persist({...this.pending,state:'complete'});
        this.status.textContent=this.labels.added;
        this.confirmedTotal=lines.reduce((sum,i)=>sum+i.final_line_price,0);
        this.querySelector('[data-total]').textContent=this.money(this.confirmedTotal);
        this.another.hidden=false;
        if(navigate) window.location.assign(this.dataset.cartUrl);
      } else if(this.pending.state==='complete') {
        this.status.textContent=this.labels.edited; this.another.hidden=false;
      } else if(!lines.length && this.pending.state==='settled') {
        const error=this.pending.error;
        this.persist(null);this.recovery.hidden=true;this.status.textContent=error ? `${this.labels.none} ${error}` : this.labels.none;
      } else {
        this.status.textContent=lines.length?this.labels.partial:this.labels.uncertain;
        this.manualRestart.hidden=!!lines.length;
      }
    }
    async addKit() {
      if(this.busy || this.pending || this.addButton.disabled) return;
      this.busy=true;this.status.textContent='';this.render();
      try {
        const before=this.selection().variants.map(v=>[v.id,v.price,v.available]);
        const [controller,strips,cart]=await Promise.all([
          this.getJSON(`products/${this.data.controller.handle}.js`),this.getJSON(`products/${this.data.strips.handle}.js`),this.cart()
        ]);
        this.data.controller=controller;this.data.strips=strips;this.data.currency=cart.currency;this.render();
        const selected=this.selection();
        if(JSON.stringify(before)!==JSON.stringify(selected.variants.map(v=>v && [v.id,v.price,v.available]))) { this.status.textContent=this.labels.changed;return; }
        if(selected.variants.some(v=>!v?.available)) { this.status.textContent=this.labels.unavailable;return; }
        const id=crypto.randomUUID();
        const items=selected.variants.map((v,i)=>({id:v.id,quantity:1,properties:{'LED kit':`Havoc ${id.slice(0,8).toUpperCase()}`,Component:i?`Channel ${i}`:'Controller',PCB:selected.color,_havoc_kit:id,_havoc_slot:i?`channel-${i}`:'controller',_havoc_channels:String(selected.count)}}));
        this.persist({id,items,state:'sending'});
        try {
          const response=await fetch(this.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify({items}),signal:AbortSignal.timeout(20000)});
          if(response.ok || response.status===422) this.persist({...this.pending,state:'settled'});
          const body=await response.json();
          if(!response.ok) this.persist({...this.pending,error:typeof body.description==='string'?body.description:this.labels.error});
        } catch { this.status.textContent=this.labels.uncertain; }
        await this.reconcile(await this.cart(),true);
      } catch { this.status.textContent=this.pending?this.labels.uncertain:this.labels.error; if(this.pending)this.recovery.hidden=false; }
      finally { this.busy=false;this.render(); }
    }
  }
  if(!customElements.get('havoc-led-kit')) customElements.define('havoc-led-kit',HavocLEDKit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
